import { Text, type TextProps } from "@mantine/core";
import type { ReactNode } from "react";

export interface IGradientTextProps extends TextProps {
  children: ReactNode;
}

const AppGradientText: React.FC<IGradientTextProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Text inherit span className={className} variant="gradient" {...rest}>
      {children}
    </Text>
  );
};

export default AppGradientText;
